import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=2058e4cd&scoped=true&"
import script from "./ChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEmail.vue?vue&type=style&index=0&id=2058e4cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058e4cd",
  null
  
)

export default component.exports